import { z } from "zod";

/** Paylasilan zod parcalari — backend/app/core/models.py enum'lariyla birebir. */

export const platformSchema = z.union([z.literal("ticimax"), z.literal("ikas"), z.literal("ideasoft"), z.literal("shopify")]);
export type Platform = z.infer<typeof platformSchema>;

export const roleSchema = z.union([z.literal("tenant_admin"), z.literal("tenant_user")]);
export type Role = z.infer<typeof roleSchema>;

export const tenantStatusSchema = z.union([
  z.literal("setup"),
  z.literal("active"),
  z.literal("suspended"),
  z.literal("archived"),
]);
export type TenantStatus = z.infer<typeof tenantStatusSchema>;

export const cardStateSchema = z.union([
  z.literal("live"),
  z.literal("not_connected"),
  z.literal("not_supported"),
]);
export type CardState = z.infer<typeof cardStateSchema>;

export const okResponseSchema = z.object({ ok: z.boolean() });
export type OkResponse = z.infer<typeof okResponseSchema>;
